import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useEngineerStore = defineStore(
  'engineer',
  () => {
    const { $apiAuthenticatedRequest, $apiUnauthenticatedRequest } = useApiRequestHelper()

    const engineerForm = ref({
      mainEngineer: null,
      engineers: [],
    })

    const activeEngineerCount = ref(0)
    const engineers = ref([])
    const session = ref({})
    const verificationData = ref({
      checkIn: {
        method: null,
        data: null,
      },
      checkOut: {
        method: null,
        data: null,
      },
    })

    const previousActiveSessions = ref([])

    const sessions = (includes = [], filters = {}) => {
      return $apiAuthenticatedRequest.index(
        'engineer-sessions',
        $apiAuthenticatedRequest.configs.index.setIncludes(includes).setFilters(filters),
      )
    }

    const getSession = (sessionId, fields = {}, includes = [], count = []) => {
      return $apiAuthenticatedRequest.get(
        'engineer-sessions',
        $apiAuthenticatedRequest.configs.get
          .setId(sessionId)
          .setIncludes(includes)
          .setFields(fields)
          .setWithCount(count),
      )
    }

    const createSession = (formData) => {
      return $apiAuthenticatedRequest.post(
        'engineer-sessions',
        $apiAuthenticatedRequest.configs.post.setData(formData),
      )
    }

    const updateSession = async (sessionId, formData, files = []) => {
      const filesToUpload = [
        {
          collection: 'engineer_session',
          files: (await $apiAuthenticatedRequest.FilePreparer.prepare(files)) ?? {},
        },
      ]

      return $apiAuthenticatedRequest.patch(
        'engineer-sessions',
        $apiAuthenticatedRequest.configs.patch
          .setId(sessionId)
          .setData(formData)
          .setFiles(filesToUpload),
      )
    }

    const fetchEngineers = async (filters = {}) => {
      return await $apiAuthenticatedRequest.index(
        'users',
        $apiAuthenticatedRequest.configs.index.setFilters(filters),
      )
    }

    const createEngineer = async (data) => {
      return $apiAuthenticatedRequest.post(
        'users',
        $apiAuthenticatedRequest.configs.post.setData(data),
      )
    }

    const reset = () => {
      engineers.value = []
      session.value = {}
    }

    return {
      activeEngineerCount,
      engineerForm,
      engineers,
      session,
      verificationData,
      previousActiveSessions,
      sessions,
      getSession,
      createSession,
      updateSession,
      fetchEngineers,
      createEngineer,
      reset,
    }
  },
  { persist: true },
)
